import type { SolutionSlug } from './solutions.config';

export function calcImpact(
  slug: SolutionSlug,
  a: { teamSize: number; systems: string[]; pain: 'tiempo'|'errores'|'crecimiento'; goals: string[] }
){
  const base = {
    'empleados-digitales': { hrs: 4, err: 35, roi: 1.8 },
    'radar-negocios':      { hrs: 3, err: 30, roi: 1.6 },
    'enfoque-laser':       { hrs: 4, err: 28, roi: 1.7 },
    'orden-datos':         { hrs: 5, err: 40, roi: 1.9 },
  }[slug];

  const teamFactor = Math.min(1 + (a.teamSize || 1) / 14, 2.2);
  const sysScore   = (a.systems.includes('excel')?0.6:0)
                   + (a.systems.includes('erp')  ?0.3:0)
                   + (a.systems.includes('crm')  ?0.2:0)
                   + (a.systems.includes('pos')  ?0.2:0)
                   + (a.systems.includes('ecom') ?0.2:0);

  const painMultiplier = a.pain === 'tiempo' ? 1.2 : a.pain === 'errores' ? 1.1 : 1.0;

  const hoursSaved     = Math.round(base.hrs * teamFactor * (1 + sysScore*0.35) * painMultiplier);
  const errorReduction = Math.min(85, Math.round(base.err + sysScore*8));
  const roiX           = Math.min(4.2, +(base.roi + (hoursSaved/12)*0.45).toFixed(1));

  const plan: string[] = [
    slug==='empleados-digitales'
      ? 'Bot para facturas y respuestas frecuentes'
      : slug==='orden-datos'
      ? 'Modelo de datos único + pipelines diarios'
      : 'Automatización priorizada por impacto'
  ];
  if (a.systems.includes('erp')) plan.push('Integración con ERP');

  return {
    hoursSaved, errorReduction, roiX, plan,
    analytics: { hoursSaved, errorReduction, roiX, teamSize: a.teamSize, sysCount: a.systems.length, pain: a.pain }
  };
}